import { render, staticRenderFns } from "./RightPanel.vue?vue&type=template&id=2ad9b066&scoped=true"
import script from "./RightPanel.vue?vue&type=script&lang=js"
export * from "./RightPanel.vue?vue&type=script&lang=js"
import style0 from "./RightPanel.vue?vue&type=style&index=0&id=2ad9b066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad9b066",
  null
  
)

export default component.exports